import { createContext, useContext, useRef, useState, type ReactNode } from 'react';
import type { OutreachBatch, OutreachEligibility } from './types';
import {useWorkspaceJourney} from './RadarJourney';

export type Preparation = {ids:string[];revision:number;saveToGmail?:boolean};
export const preparationReasons:Record<string,string>={
  no_email:'No sourced email found',no_supported_match:'No matching material · review the hook',
  budget_limited:'Research budget reached',research_failed:'Research failed',contact_blocked:'Contact route unavailable',
  in_progress:'Already preparing or drafted',reserved:'Draft already in Gmail',contacted:'Already contacted',
  suppressed:'Do not contact',not_fit:'Marked Not Fit',
};
type Flow = {
 gmailAvailable:boolean;setGmailAvailable:(value:boolean)=>void;
 selectionRevision:number;completePreparation:()=>void;
 batches:OutreachBatch[];setBatches:(value:OutreachBatch[])=>void;notice:string;setNotice:(value:string)=>void;
 eligibilityLimited:boolean;setEligibilityLimited:(v:boolean)=>void;
 eligibility:OutreachEligibility[]|null;setEligibility:(v:OutreachEligibility[])=>void;
 preparation?:Preparation;consumePreparation:(revision:number)=>void;prepare:(ids:string[])=>void;
 focusRevision:number;focusedCompany:string|null;focus:(key:string)=>void;
 eligibleOnly:boolean;setEligibleOnly:(v:boolean)=>void;discover:()=>void;
};
const Context=createContext<Flow|null>(null);
export const useOutreachFlow=()=>useContext(Context);
export function RadarOutreachFlowProvider({children,onNavigate,enabled=true}:{children:ReactNode;enabled?:boolean;onNavigate:(section:'discover'|'act')=>void}) {
 const journey=useWorkspaceJourney();
 const [eligibilityLimited,setEligibilityLimited]=useState(false);
 const [gmailAvailable,setGmailAvailable]=useState(false),[selectionRevision,setSelectionRevision]=useState(0);
 const [batches,setBatches]=useState<OutreachBatch[]>([]),[notice,setNotice]=useState('');
 const [eligibility,setEligibility]=useState<OutreachEligibility[]|null>(null);
 const preparationRevision=useRef(0);
 const [preparation,setPreparation]=useState<Preparation>();
 const [focusRevision,setFocusRevision]=useState(0);
 const [focusedCompany,setFocusedCompany]=useState<string|null>(null);
 const [eligibleOnly,setEligibleOnly]=useState(false);
 return <Context.Provider value={enabled?{gmailAvailable,setGmailAvailable,selectionRevision,completePreparation:()=>setSelectionRevision(n=>n+1),batches,setBatches,notice,setNotice,eligibilityLimited,setEligibilityLimited,eligibility,setEligibility,preparation,focusRevision,focusedCompany,eligibleOnly,setEligibleOnly,
   consumePreparation:revision=>setPreparation(p=>p?.revision===revision?undefined:p),
   prepare:ids=>{setPreparation({ids,revision:++preparationRevision.current,saveToGmail:journey&&gmailAvailable});setFocusedCompany(null);if(!journey)onNavigate('act');},
   focus:key=>{setFocusedCompany(key);setFocusRevision(n=>n+1);onNavigate('act');},
   discover:()=>{setEligibleOnly(true);onNavigate('discover');}}:null}>{children}</Context.Provider>;
}
